(() => {
  const configNode = document.getElementById('FuntoTrackMotionConfig');
  if (!configNode) return;
  const {van} = JSON.parse(configNode.textContent);
  let scheduled = false;
  const white = color => {
    const parts = color.match(/[\d.]+/g)?.map(Number);
    return parts && parts.length >= 3 && parts.slice(0,3).every(n => n >= 245) && (parts.length < 4 || parts[3] >= .9);
  };
  const mount = () => {
    scheduled = false;
    if (document.getElementById('FuntoMotion-TR01')?.isConnected) return;
    const root = document.getElementById('track123-app');
    if (!root) return;
    const inputs = [...root.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])')].filter(input => input.getClientRects().length);
    let card = null;
    for (const input of inputs) {
      for (let node = input.parentElement; node && node !== root; node = node.parentElement) {
        const rect = node.getBoundingClientRect();
        if (rect.width < 240 || rect.width > 720 || rect.height < 120) continue;
        if (!node.querySelector('button, input[type="submit"], [role="button"]')) continue;
        if (!white(getComputedStyle(node).backgroundColor)) continue;
        card = node;
        break;
      }
      if (card) break;
    }
    if (!card) return;
    if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
    card.classList.add('funto-track-motion-card');
    const scene = document.createElement('span');
    scene.id = 'FuntoMotion-TR01';
    scene.className = 'funto-track-van';
    scene.dataset.funtoMotionId = 'TR01';
    scene.setAttribute('aria-hidden','true');
    const img = document.createElement('img');
    img.src = van;
    img.width = 127;
    img.height = 55;
    img.alt = '';
    img.decoding = 'async';
    const label = document.createElement('span');
    label.className = 'funto-track-van__number';
    label.textContent = 'TR01';
    scene.append(img,label);
    card.prepend(scene);
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(mount); }
  };
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  addEventListener('load',schedule,{once:true});
  mount();
})();

